/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AiReservationControllerCreateReservationBodyRequest {
  hospitalId: string;
  /** 환자(HService) ID */
  patientId?: string | null;
  /** 환자 이름 */
  patientName: string;
  /** 환자 전화번호 */
  patientPhone: string;
  /** 예약 일시 */
  datetime?: string | null;
  /** Twilio Call SID */
  callSid?: string | null;
  /** Chat ID */
  chatId?: string | null;
  /** 예약 메모 */
  note?: string | null;
}

export interface AiReservationControllerCreateReservationResponse {
  code: number;
  data: {
    /** 예약 ID */
    reservationId: string;
    /** 예약 일시 */
    datetime: string;
    /** 환자(HService) ID */
    hserviceId: string;
  };
  message: string;
}

export interface AiReservationControllerGetAvailableDateSlotsResponse {
  code: number;
  data: {
    /** 예약 가능한 일자 목록 */
    dates: string[];
  };
  message: string;
}

export interface AiReservationControllerGetAvailableTimeSlotsResponse {
  code: number;
  data: {
    /** 예약 가능한 시간 목록 */
    slots: string[];
  };
  message: string;
}

export interface AiReservationControllerGetAvailableSingleSlotResponse {
  code: number;
  data: {
    /** 해당 일시에 예약 가능한지 여부 */
    available: boolean;
  };
  message: string;
}

export interface AiReservationControllerGetAvailableSlotsResponse {
  code: number;
  data: {
    /** 예약 가능한 시간 목록 */
    dates: string[];
  };
  message: string;
}

export interface AiReservationControllerGetAiReservationHistoryResponse {
  code: number;
  data: {
    /** AI 예약 히스토리 목록 */
    items: {
      /** 예약 ID */
      reservationId: string;
      /** 예약 일시 */
      reservationDateTime: string;
      /** 예약 상태 */
      reservationStatus: "pending" | "confirmed" | "canceled" | "deleted";
      /** 환자 ID */
      patientId: string;
      /** 환자 이름 */
      patientName: string;
      /** 환자 전화번호 */
      patientPhone: string;
      /** 예약 소스 */
      reservationSourceType: "call" | "afterdoc" | "kakao" | "insta" | "talktalk" | "line" | "wechat" | "whatsapp";
      /** 예약 소스 계정 */
      reservationSourceAccount?: string | null;
      /** 생성 일시 */
      createdAt: string;
    }[];
    /** 총 건수 */
    total: number;
    /** 오프셋 */
    offset: number;
    /** 리밋 */
    limit: number;
  };
  message: string;
}

export interface AiReservationControllerGetAiReservationHistoryCountResponse {
  code: number;
  data: {
    /** 예약 히스토리 수 */
    count: number;
  };
  message: string;
}

export interface AiServiceNoticeControllerFindListResponse {
  code: number;
  data: {
    items: {
      /** 공지 ID */
      _id: string;
      /** 병원 ID */
      hospitalId: string;
      applicationType: "ai-call-manager" | "ai-coach" | "ai-global-coordinator";
      /** applicationType별 payload (AiServiceNoticePushData) */
      data: {
        noticeType: "needCheck" | "provisionalReservation";
        callSid?: string;
        callerNumber?: string;
        callHistoryId?: string;
        patientInfo?: {
          id: string;
          name: string;
        } | null;
        chatRoomId?: string;
        patientName?: string;
        configIssueType?: string;
        forwardingLoopLineNumber?: string;
      };
      /** 현재 사용자 기준 읽음 여부 (readInfo[userId].isRead) */
      isRead: boolean;
      createdAt?: string | null;
    }[];
    /** 조건에 맞는 전체 건수 (페이지네이션용) */
    totalCount: number;
    /** 조건에 맞는 미읽음 전체 건수 (현재 사용자 기준) */
    totalUnreadCount: number;
  };
  message: string;
}

export interface AiServiceNoticeControllerUpdateReadBodyRequest {
  /** AI 서비스 공지 ID */
  noticeId: string;
}

export interface AiServiceNoticeControllerUpdateReadResponse {
  code: number;
  data: {
    /** 읽음 처리 성공 여부 */
    success: boolean;
  };
  message: string;
}

export interface AiServiceNoticeControllerUpdateReadAllResponse {
  code: number;
  data: {
    /** 읽음 처리 성공 여부 */
    success: boolean;
  };
  message: string;
}

export interface AiDashboardControllerGetCurrentMonthUsageResponse {
  code: number;
  data: {
    /** 이번 달 총 AI 요청 횟수 (가중치 적용) */
    totalRequestCount: number;
    /** 이번 달 총 사용 비용 (원) */
    totalCost: number;
    /** 이번 달 총 할인 금액 (원) */
    totalDiscount: number;
    /** 예상 월 사용료 (현재까지 일 평균 비용 기반 추정) */
    estimatedMonthlyCost: number;
    /** AI가 응대한 고객 수 (이탈 방지 고객) */
    retainedCustomer: {
      /** AI 채팅으로 응대한 고객 수 */
      chat: number;
      /** AI 전화로 응대한 고객 수 */
      phone: number;
      /** 환자 등록된 고객 수 */
      registeredCount: number;
    };
    /** AI vs 사용자 응대 비율 */
    aiResponseRatio: {
      /** 채팅 응대 비율 */
      chat: {
        /** AI 응대 건수 */
        aiCount: number;
        /** 사용자(병원) 응대 건수 */
        userCount: number;
      };
      /** 전화 응대 비율 */
      call: {
        /** AI 응대 건수 */
        aiCount: number;
        /** 사용자(병원) 응대 건수 */
        userCount: number;
      };
      /** 예약 응대 비율 */
      reservation: {
        /** AI 응대 건수 */
        aiCount: number;
        /** 사용자(병원) 응대 건수 */
        userCount: number;
      };
    };
  };
  message: string;
}

export interface AiDashboardControllerGetMonthlyStatsResponse {
  code: number;
  data: {
    /** 최근 6개월 월별 사용 통계 */
    monthlyStats: {
      /** 연도 */
      year: number;
      /** 월 */
      month: number;
      /** 애플리케이션 타입별 사용 통계 */
      byApplicationType: {
        /** 애플리케이션 타입 */
        applicationType: "ai-call-manager" | "ai-coach" | "ai-global-coordinator";
        /** 해당 타입의 AI 요청 횟수 (가중치 적용) */
        requestCount: number;
        /** 해당 타입의 사용 비용 (원) */
        cost: number;
        /** 해당 타입의 할인 금액 (원) */
        discount: number;
      }[];
    }[];
  };
  message: string;
}

export interface AiDashboardControllerGetBillingFailureResponse {
  code: number;
  data: {
    /** 결제 실패건 존재 여부 */
    hasBillingFailure: boolean;
    /** 결제 실패 월 목록 (e.g. [6, 7]) */
    failedMonths: number[];
  };
  message: string;
}

export interface AiDashboardControllerGetDiscountPolicyResponse {
  code: number;
  data: {
    /** 할인 정책 목록 */
    policies: {
      /** 할인 정책 이름 */
      title: string;
      /** 앱 표시명 */
      appName: string;
      /** 앱 코드명 */
      codeName: "ai-coach" | "ai-global-coordinator" | "ai-call-manager";
      /** 할인율 (%) */
      percentOff: number;
      /** 할인 금액 (원) */
      amountOff: number;
      /** 할인 시작일 */
      effectiveStartAt?: string | null;
      /** 할인 종료일 */
      effectiveEndAt?: string | null;
      /** 할인 정책 설명 */
      description?: string | null;
    }[];
  };
  message: string;
}

export type AiReservationControllerCreateReservationData = AiReservationControllerCreateReservationResponse;

export interface AiReservationControllerGetAvailableDateSlotsParams {
  /** 병원 ID */
  hospitalId: string;
  /** 조회 일자 중, 예약이 가능한 시작시간 (HH:mm 형식) */
  startTime?: string | null;
  /** 조회 일자 중, 예약이 가능한 종료시간 (HH:mm 형식) */
  endTime?: string | null;
  /**
   * 조회 결과 개수 제한
   * @default 90
   */
  limit?: number | null;
}

export type AiReservationControllerGetAvailableDateSlotsData = AiReservationControllerGetAvailableDateSlotsResponse;

export interface AiReservationControllerGetAvailableTimeSlotsParams {
  /** 병원 ID */
  hospitalId: string;
  /** 예약 일자 */
  date: string;
}

export type AiReservationControllerGetAvailableTimeSlotsData = AiReservationControllerGetAvailableTimeSlotsResponse;

export interface AiReservationControllerGetAvailableSingleSlotParams {
  /** 병원 ID */
  hospitalId: string;
  /** 예약 가능 여부를 확인할 일시 (ISO-8601, 예: 2026-04-24T05:00:00Z) */
  datetime: string;
}

export type AiReservationControllerGetAvailableSingleSlotData = AiReservationControllerGetAvailableSingleSlotResponse;

export interface AiReservationControllerGetAvailableSlotsParams {
  /** 병원 ID */
  hospitalId: string;
  /** 시작 시간 */
  startedAt: string;
  /** 종료 시간 */
  endedAt: string;
}

export type AiReservationControllerGetAvailableSlotsData = AiReservationControllerGetAvailableSlotsResponse;

export interface AiReservationControllerGetAiReservationHistoryParams {
  /** 병원 ID */
  hospitalId: string;
  /** 필터 타입 - 이름 혹은 휴대폰번호 */
  filterType?: "name" | "phone" | null;
  /** 검색어 - 이름 혹은 휴대폰번호 */
  filterValue?: string | null;
  /** 예약 상태 */
  reservationStatus?: "pending" | "confirmed" | "canceled" | "deleted" | null;
  /** 예약 시작 일시 필터 ISO-8601 형식 (ex, 2026-03-04T00:00:00+09:00) */
  startedAt?: string | null;
  /** 예약 종료 일시 필터 ISO-8601 형식 (ex, 2026-03-04T00:00:00+09:00) */
  endedAt?: string | null;
  /**
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /**
   * @min 1
   * @max 100
   * @default 15
   */
  limit?: number;
}

export type AiReservationControllerGetAiReservationHistoryData = AiReservationControllerGetAiReservationHistoryResponse;

export interface AiReservationControllerGetAiReservationHistoryCountParams {
  /** 병원 ID */
  hospitalID: string;
  /** 예약 시작 일시 필터 ISO-8601 형식 (ex, 2026-03-04T00:00:00+09:00) */
  startedAt?: string | null;
  /** 예약 종료 일시 필터 ISO-8601 형식 (ex, 2026-03-04T00:00:00+09:00) */
  endedAt?: string | null;
  /** 예약 상태 */
  status?: "pending" | "confirmed" | "cancelled" | "deleted" | null;
}

export type AiReservationControllerGetAiReservationHistoryCountData =
  AiReservationControllerGetAiReservationHistoryCountResponse;

export interface AiServiceNoticeControllerFindParams {
  /**
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /**
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /** data.noticeType 필터 (needCheck | provisionalReservation) */
  noticeType?: "needCheck" | "provisionalReservation";
}

export type AiServiceNoticeControllerFindData = AiServiceNoticeControllerFindListResponse;

export type AiServiceNoticeControllerUpdateReadData = AiServiceNoticeControllerUpdateReadResponse;

export type AiServiceNoticeControllerUpdateReadAllData = AiServiceNoticeControllerUpdateReadAllResponse;

export type AiDashboardControllerGetCurrentMonthUsageData = AiDashboardControllerGetCurrentMonthUsageResponse;

export interface AiDashboardControllerGetMonthlyStatsParams {
  /**
   * 조회 연도
   * @min 2020
   * @max 2100
   */
  year: number;
  /**
   * 조회 월
   * @min 1
   * @max 12
   */
  month: number;
}

export type AiDashboardControllerGetMonthlyStatsData = AiDashboardControllerGetMonthlyStatsResponse;

export type AiDashboardControllerGetBillingFailureData = AiDashboardControllerGetBillingFailureResponse;

export type AiDashboardControllerGetDiscountPolicyData = AiDashboardControllerGetDiscountPolicyResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 예약 생성
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerCreateReservation
     * @summary 예약 생성
     * @request POST:/v3/api/ai/reservation/create
     * @secure
     * @response `200` `AiReservationControllerCreateReservationData` success
     */
    aiReservationControllerCreateReservation: (
      data: AiReservationControllerCreateReservationBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerCreateReservationData, any>({
        path: `/v3/api/ai/reservation/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 예약 가능한 일자 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAvailableDateSlots
     * @summary 예약 가능한 일자 조회
     * @request GET:/v3/api/ai/reservation/available-date
     * @secure
     * @response `200` `AiReservationControllerGetAvailableDateSlotsData` success
     */
    aiReservationControllerGetAvailableDateSlots: (
      query: AiReservationControllerGetAvailableDateSlotsParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAvailableDateSlotsData, any>({
        path: `/v3/api/ai/reservation/available-date`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 예약 가능한 일자 기준 시간 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAvailableTimeSlots
     * @summary 예약 가능한 일자 기준 시간 조회
     * @request GET:/v3/api/ai/reservation/available-time
     * @secure
     * @response `200` `AiReservationControllerGetAvailableTimeSlotsData` success
     */
    aiReservationControllerGetAvailableTimeSlots: (
      query: AiReservationControllerGetAvailableTimeSlotsParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAvailableTimeSlotsData, any>({
        path: `/v3/api/ai/reservation/available-time`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 일시의 예약 가능 여부 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAvailableSingleSlot
     * @summary 특정 일시의 예약 가능 여부 조회
     * @request GET:/v3/api/ai/reservation/available-single
     * @secure
     * @response `200` `AiReservationControllerGetAvailableSingleSlotData` success
     */
    aiReservationControllerGetAvailableSingleSlot: (
      query: AiReservationControllerGetAvailableSingleSlotParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAvailableSingleSlotData, any>({
        path: `/v3/api/ai/reservation/available-single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 예약 가능한 시간 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAvailableSlots
     * @summary 예약 가능한 시간 조회
     * @request GET:/v3/api/ai/reservation/available
     * @secure
     * @response `200` `AiReservationControllerGetAvailableSlotsData` success
     */
    aiReservationControllerGetAvailableSlots: (
      query: AiReservationControllerGetAvailableSlotsParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAvailableSlotsData, any>({
        path: `/v3/api/ai/reservation/available`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 예약 히스토리 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAiReservationHistory
     * @summary AI 예약 히스토리 조회
     * @request GET:/v3/api/ai/reservation/history
     * @secure
     * @response `200` `AiReservationControllerGetAiReservationHistoryData` success
     */
    aiReservationControllerGetAiReservationHistory: (
      query: AiReservationControllerGetAiReservationHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAiReservationHistoryData, any>({
        path: `/v3/api/ai/reservation/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 예약 히스토리 수 조회
     *
     * @tags V3-Ai-Reservation
     * @name AiReservationControllerGetAiReservationHistoryCount
     * @summary AI 예약 히스토리 수 조회
     * @request GET:/v3/api/ai/reservation/history/count
     * @secure
     * @response `200` `AiReservationControllerGetAiReservationHistoryCountData` success
     */
    aiReservationControllerGetAiReservationHistoryCount: (
      query: AiReservationControllerGetAiReservationHistoryCountParams,
      params: RequestParams = {},
    ) =>
      this.request<AiReservationControllerGetAiReservationHistoryCountData, any>({
        path: `/v3/api/ai/reservation/history/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Ai-ServiceNotice
     * @name AiServiceNoticeControllerFind
     * @summary AI 서비스 공지 목록 조회 (페이지네이션: limit, offset, data.noticeType 필터)
     * @request GET:/v3/api/ai/service-notices
     * @secure
     * @response `200` `AiServiceNoticeControllerFindData` success
     */
    aiServiceNoticeControllerFind: (query: AiServiceNoticeControllerFindParams, params: RequestParams = {}) =>
      this.request<AiServiceNoticeControllerFindData, any>({
        path: `/v3/api/ai/service-notices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Ai-ServiceNotice
     * @name AiServiceNoticeControllerUpdateRead
     * @summary AI 서비스 공지 읽음 처리 (body: noticeId)
     * @request POST:/v3/api/ai/service-notices/read
     * @secure
     * @response `200` `AiServiceNoticeControllerUpdateReadData` success
     */
    aiServiceNoticeControllerUpdateRead: (
      data: AiServiceNoticeControllerUpdateReadBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AiServiceNoticeControllerUpdateReadData, any>({
        path: `/v3/api/ai/service-notices/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Ai-ServiceNotice
     * @name AiServiceNoticeControllerUpdateReadAll
     * @summary AI 서비스 공지 읽음 처리 (모두 읽음 처리)
     * @request POST:/v3/api/ai/service-notices/read/all
     * @secure
     * @response `200` `AiServiceNoticeControllerUpdateReadAllData` success
     */
    aiServiceNoticeControllerUpdateReadAll: (params: RequestParams = {}) =>
      this.request<AiServiceNoticeControllerUpdateReadAllData, any>({
        path: `/v3/api/ai/service-notices/read/all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 이번 달 운영 현황 조회
     *
     * @tags V3-Ai-Dashboard
     * @name AiDashboardControllerGetCurrentMonthUsage
     * @summary 이번 달 AI 기능 동작 횟수, 토큰 사용량, 비용, AI 채팅 건수 (한국시간 기준)
     * @request GET:/v3/api/ai/dashboard/usage/current
     * @secure
     * @response `200` `AiDashboardControllerGetCurrentMonthUsageData` success
     */
    aiDashboardControllerGetCurrentMonthUsage: (params: RequestParams = {}) =>
      this.request<AiDashboardControllerGetCurrentMonthUsageData, any>({
        path: `/v3/api/ai/dashboard/usage/current`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 월별 현황 조회
     *
     * @tags V3-Ai-Dashboard
     * @name AiDashboardControllerGetMonthlyStats
     * @summary 요청한 달 기준 최근 6개월 토큰 사용량, AI 채팅 건수 (applicationType별 분류 포함)
     * @request GET:/v3/api/ai/dashboard/usage/monthly
     * @secure
     * @response `200` `AiDashboardControllerGetMonthlyStatsData` success
     */
    aiDashboardControllerGetMonthlyStats: (
      query: AiDashboardControllerGetMonthlyStatsParams,
      params: RequestParams = {},
    ) =>
      this.request<AiDashboardControllerGetMonthlyStatsData, any>({
        path: `/v3/api/ai/dashboard/usage/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 결제 실패 여부 조회
     *
     * @tags V3-Ai-Dashboard
     * @name AiDashboardControllerGetBillingFailure
     * @summary 결제 실패건 존재 여부 및 실패 월 목록 조회
     * @request GET:/v3/api/ai/dashboard/billing-failure
     * @secure
     * @response `200` `AiDashboardControllerGetBillingFailureData` success
     */
    aiDashboardControllerGetBillingFailure: (params: RequestParams = {}) =>
      this.request<AiDashboardControllerGetBillingFailureData, any>({
        path: `/v3/api/ai/dashboard/billing-failure`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 최초 무료 할인정책 조회
     *
     * @tags V3-Ai-Dashboard
     * @name AiDashboardControllerGetDiscountPolicy
     * @summary 최초 무료 할인정책 조회
     * @request GET:/v3/api/ai/dashboard/usage/discount-policy
     * @secure
     * @response `200` `AiDashboardControllerGetDiscountPolicyData` success
     */
    aiDashboardControllerGetDiscountPolicy: (params: RequestParams = {}) =>
      this.request<AiDashboardControllerGetDiscountPolicyData, any>({
        path: `/v3/api/ai/dashboard/usage/discount-policy`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
